import { NumberPlates } from './NumberPlates';

export default NumberPlates;
